var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.kC=$CLJS.Xe($CLJS.Th());